// extracted by mini-css-extract-plugin
module.exports = {"parallelogram":"shared_parallelogram__sLDFF","parallelogramNoAffordance":"shared_parallelogramNoAffordance__Jt_fG"};